/* eslint-disable react/prop-types */
import { Typography } from "antd";
import { TRAINING_TYPE_LABELS, TRAINING_TYPE_COLORS } from "../utils/trainingCatalog.constants";

/**
 * TrainingTypeTag Component
 * Displays training type with appropriate color
 * @param {Object} props
 * @param {string} props.type - Training type (reguler, akselerasi, sertifikasi)
 */
export default function TrainingTypeTag({ type }) {
  const label = TRAINING_TYPE_LABELS[type] || "-";
  const color = TRAINING_TYPE_COLORS[type];

  if (!type) {
    return <Typography.Text>-</Typography.Text>;
  }

  return (
    <Typography.Text
      style={{
        color: color,
        fontWeight: 500,
      }}
    >
      {label}
    </Typography.Text>
  );
}
